/**
 * Copyright (c) 2019, WSO2 Inc. (http://www.wso2.org) All Rights Reserved.
 *
 * WSO2 Inc. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import {getSessionParameter, resetAuthenticatedSession} from "./session";
// import {CONFIG} from "../config";

/**
 * Logs out from the session.
 */
export const dispatchLogout = () => {
    const token = getSessionParameter("ID_TOKEN");
    // Clear the session storage
    resetAuthenticatedSession();
    window.location.href = `${process.env.REACT_APP_SSO.LOGOUT_URL}?id_token_hint=${token}&post_logout_redirect_uri=${process.env.REACT_APP_SSO.REDIRECT_URI}`;
};
